// sp-ecrit.js — un écrit, carte 50 (Signal v8, 06/10).
//
// La partie en cours est celle dont le haut a passé le milieu de l'écran. Elle remplit les
// carrés du fil jusqu'à elle (lu / actif) et ceux de l'avancement, écrit « Partie 03 / 09 »
// et « ≈ 6 min restantes » — calculées sur la longueur des parties restantes (mots ÷ 200),
// pas sur la hauteur — et affiche dans le panneau les références que l'auteur a rattachées
// à cette partie (métachamp custom.refs_parties, rendu en <template>).
//
// Calcul au défilement, pas IntersectionObserver : il se lit et se vérifie (sp-concept.js).
// Sans JavaScript, la page ne perd rien : le panneau montre l'œuvre et la partie 01.
(function () {
  var ecr = document.querySelector('[data-sp-ecr]');
  if (!ecr) return;
  var parts = [].slice.call(ecr.querySelectorAll('[data-sp-part]'));
  if (!parts.length) return;

  // Deux rangées d'avancement (la barre du téléphone, le panneau du bureau) : chacune ses carrés.
  var rangees = [].slice.call(ecr.querySelectorAll('[data-sp-avance]')).map(function (r) { return [].slice.call(r.querySelectorAll('.sp-carre')); });
  var pos = ecr.querySelector('[data-sp-pos]');
  var reste = ecr.querySelector('[data-sp-reste]');
  var box = ecr.querySelector('[data-sp-refbox]');
  var boxC = ecr.querySelector('[data-sp-refbox-c]');
  var total = parts.length;
  var mots = parts.map(function (p) { return parseInt(p.getAttribute('data-sp-mots'), 10) || 0; });
  var modelePos = pos ? pos.textContent : '';
  var modeleReste = reste ? reste.getAttribute('data-sp-reste-modele') : '';
  var pad = function (n) { return ('0' + n).slice(-2); };
  var dernier = null;
  var minuteur = null;

  function refs(n) {
    if (!box || !boxC) return;
    var tpl = ecr.querySelector('template[data-sp-refs="' + n + '"]');
    clearTimeout(minuteur);
    if (!tpl) { box.hidden = true; boxC.innerHTML = ''; return; }
    box.classList.add('is-off');
    minuteur = setTimeout(function () {
      boxC.innerHTML = '';
      boxC.appendChild(tpl.content.cloneNode(true));
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.remove('is-off'); });
    }, box.hidden ? 0 : 180);
  }

  function maj() {
    var milieu = window.innerHeight / 2;
    var n = 1;
    parts.forEach(function (p) { if (p.getBoundingClientRect().top <= milieu) n = +p.getAttribute('data-sp-part'); });
    if (n === dernier) return;
    dernier = n;
    parts.forEach(function (p) { p.classList.toggle('is-lu', +p.getAttribute('data-sp-part') <= n); });
    rangees.forEach(function (cs) { cs.forEach(function (c, i) { c.classList.toggle('sp-carre--vide', i + 1 > n); }); });
    if (pos) pos.textContent = modelePos.replace(/\d+(\s*\/)/, pad(n) + '$1');
    if (reste && modeleReste) {
      var m = 0;
      for (var i = n - 1; i < total; i++) m += mots[i];
      reste.textContent = modeleReste.replace('999', Math.max(1, Math.round(m / 200)));
    }
    refs(n);
  }

  maj();
  window.addEventListener('scroll', maj, { passive: true });
  window.addEventListener('resize', function () { dernier = null; maj(); });
})();
